<template>
  <div class="home" :class="isMobile == 1 ? 'home-m' : ''">
    <swiper></swiper>

    <div class="block_1_bg">
      <div class="block_1">
        <div class="item" v-for="(item, index) in block_1_list" :key="index">
          <img class="l" src="../assets/004.png" alt="">
          <div class="r">
            <div class="txt1">{{ item.txt1 }}</div>
            <div class="txt2">{{ item.txt2 }}</div>
            <div class="txt3">{{ item.txt3 }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="block_2_bg">
      <div class="block_2">
        <div class="l">
          <div class="txt1">展创云（上海）信息技术服务有限公司</div>
          <div class="txt2">Zhanchuangyun (Shanghai)
            Information Technology
            Service Co., Ltd
          </div>
          <div class="txt3">展创云（ZCY
            Tech）专注于会展行业信息技术服务及门禁管理服务商，我们致力于为主办方、参展商、参观观众提供CRM管理系统、参展商管理系统、观众数据库管理系统、观众预约登记接待服务、门禁管理服务及印刷制作服务。展创云服务团队成员在行业均有超过五年以上服务经验，全国服务超过30多个城市，年均服务过的展会和会议项目超100场，累计服务项目超过1000场。
            展创云（ZCY
            Tech）致力于签到服务、门禁管理服务，为客户提供稳定且符合业务需求特点的定制化服务系统，让客户更轻松的管理参展商及邀约观众。同时我们也会根据项目的特点，给出完整的现场服务解决方案，解放客户，让客户更专注于服务好参展商。
          </div>
          <img class="img3" @click="$router.replace('/guanyu')" src="../assets/007.png" alt="">
          <div class="txt4">ZCY Tech</div>
        </div>
        <div class="r">
          <img class="img1" src="../assets/005.png" alt="">
          <img class="img2" src="../assets/006.png" alt="">
        </div>
      </div>
      <div class="block_3">

        <div class="title-box">
          <div class="title-en">PRODUCTS AND SERVICES</div>
          <div class="title-cn">
            <span></span>
            产品和服务
            <span></span>
          </div>
        </div>

        <div class="cont">
          <img src="../assets/008.png" @click="$router.replace('/ruanjian')" alt="">
          <img src="../assets/009.png" @click="$router.replace('/yingjian')" alt="">
          <img src="../assets/010.png" @click="$router.replace('/hujiao')" alt="">
          <img src="../assets/011.png" @click="$router.replace('/zhengjian')" alt="">
          <img src="../assets/012.png" @click="$router.replace('/renyuan')" alt="">
        </div>

      </div>
    </div>

    <div class="block_4_bg">
      <div class="block_4">

        <div class="title-box">
          <div class="title-en">NEWS CENTRES</div>
          <div class="title-cn">
            <span></span>
            资讯中心
            <span></span>
          </div>
        </div>

        <div class="cont">
          <div class="l">
            <img src="../assets/013.png" alt="">
            <div class="item" @click="redirectToBaidu(zixun_list[0].url)">
              <div class="title">{{ zixun_list[0].title }}</div>
              <div class="jieshao">{{ zixun_list[0].details }}</div>
            </div>
          </div>
          <div class="r">
            <!-- <div class="item" v-for="(item, index) in zixun_list" :key="index" v-if="index > 0 && index < 4"  @click="$router.replace('/zixun-details')"> -->
            <div class="item" v-for="(item, index) in zixun_list" :key="index" v-if="index > 0 && index < 4"  @click="redirectToBaidu(item.url)">
            <!-- <div class="item" v-for="(item, index) in zixun_list" :key="index" v-if="index > 0 && index < 4"  @click="$router.replace(item.url)"> -->
              <div class="title">{{ item.title }}</div>
              <div class="jieshao">{{ item.details }}</div>
              <div class="bott">
                <div class="time">{{ item.date }}</div>
                <div class="bott-r">
                  <span>详情</span>
                  <i class="el-icon-arrow-right"></i>
                </div>
              </div>
            </div>
          </div>
        </div>


      </div>
    </div>

    <div class="block_5_bg">
      <div class="block_5">

        <div class="top">
          <div class="btn" @click="moveLeft">
            <i class="el-icon-arrow-left"></i>
          </div>
          <div class="btn" @click="moveRight">
            <i class="el-icon-arrow-right"></i>
          </div>
        </div>

        <div class="bott">

          <div class="l">
            <div class="txt1">SERVICE CASES</div>
            <div class="txt2">服务案例</div>
            <div class="txt3">全国服务超过30多个城市，年均服务过的展会和会议项目超100场，累计服务项目超过1000场。</div>
            <img class="img1" src="../assets/017.png" alt="">
            <div class="txt4">ZCY Tech</div>
          </div>

          <div class="r">

            <div class="item" v-for="(item, index) in anli_list" :key="index"
              :style="{ transform: 'translateX(' + translateX + 'px)' }">
              <img class="img" :src="require('@/assets/' + item.img0)" alt="">
              <div class="info">
                <div class="title">{{ item.title }}</div>
                <div class="show show-s">主办方：{{ item.zhuban }}</div>
                <div class="show">面积：{{ item.mianji }}</div>
                <div class="show show-s">{{ item.date }}</div>
              </div>
            </div>
          </div>
        </div>


      </div>
    </div>


    <!-- <HelloWorld msg="Welcome to Your Vue.js App"/> -->
  </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'
import swiper from '@/components/swiper.vue'
import zixunlist from '../../zixun.json'
import anlilist from '../../anli2.json'
export default {
  name: 'HomeView',
  components: {
    swiper
  },
  data() {
    return {
      isMobile: false,
      // 在数据属性中存储 window 对象
      windowObj: window,
      block_1_list: [
        {
          txt1: '专注',
          txt2: '门禁服务',
          txt3: '专注会展行业信息技术服务及门禁管理服务商 ',
        },
        {
          txt1: '五年以上',
          txt2: '团队成员',
          txt3: '展创云项目经理均有五年以上行业经验，人均年服务展会项目20场 ',
        },
        {
          txt1: '70%',
          txt2: '系统服务',
          txt3: '目前服务项目中有70%项目涉及提供系统服务，如：小程序开发服务、观众登记系统、展商管理系统、观众邀约系统等。 ',
        },
        {
          txt1: '100场',
          txt2: '现场服务',
          txt3: '年服务超100场服务中，其中现场接待服务占90%，会议接待服务占10%。 ',
        }
      ],
      zixun_list: [],
      anli_list: [],
      translateX: 0
    };
  },
  created() {
    // this.$nextTick(()=>{
    // this.isMobile = localStorage.getItem("isMobile")
    // })
    this.zixun_list = zixunlist.list
    this.anli_list = anlilist.list
    console.log(zixunlist);
    if (this._isMobile()) {
      console.log('手机端')
      this.isMobile = true
    } else {
      this.isMobile = false
    }
  },
  methods: {
    // 判断是否是手机端，如果是，返回true
    _isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag
    },
    redirectToBaidu(url) {
      // 使用 window.location.href 跳转到百度页面
      this.windowObj.open(url, '_blank');
    },
    moveLeft() {
      console.log('left====',this.translateX);
      let num = this.anli_list.length
      console.log('num',(num - 3) * 378);
      if((num - 3) * 378 > -this.translateX){
      this.translateX -= 378;
      }
      
    },

    moveRight() {
      console.log(this.translateX );
      if (this.translateX != 0) {
        this.translateX += 378;
      }
    },

  }
}
</script>
<style scoped lang='less'>
.block_1_bg {
  width: 100%;
  height: 317px;
  background: linear-gradient(-90deg, #1A3994 0%, #4E5EAA 100%);
  border-top: 1px solid #C8C8C8;

  .block_1 {
    width: 1440px;
    margin: 0 auto;
    display: flex;

    .item {
      flex: 1;
      display: flex;

      .l {
        width: 7px;
        height: 100%;
        flex-shrink: 0;
      }

      .r {
        box-sizing: border-box;
        padding: 30px 30px;

        .txt1 {
          font-size: 40px;
          // font-family: SourceHanSansSC-Heavy, SourceHanSansSC;
          font-weight: 800;
          color: #FFFFFF;
        }

        .txt2 {
          font-size: 28px;
          // font-family: SourceHanSansSC-Medium, SourceHanSansSC;
          font-weight: 500;
          color: #FFFFFF;
          margin: 15px 0;
        }

        .txt3 {
          font-size: 18px;
          // font-family: SourceHanSansSC-Regular, SourceHanSansSC;
          font-weight: 400;
          color: #FFFFFF;
          line-height: 36px;
        }
      }
    }
  }
}

.block_2_bg {
  width: 100%;
  background: #fff;
  padding: 140px 0;

  .block_2 {
    width: 1440px;
    margin: 0 auto;
    display: flex;

    .l {
      .txt1 {
        font-size: 36px;
        // font-family: SourceHanSansSC-Medium, SourceHanSansSC;
        font-weight: 500;
        color: #1B3995;
        line-height: 66px;
      }

      .txt2 {
        font-size: 50px;
        // font-family: Arial-BoldMT, Arial;
        font-weight: 700;
        color: #3B4F9F;
        line-height: 68px;
        margin: 30px 0 50px;
      }

      .txt3 {
        font-size: 24px;
        // font-family: SourceHanSansSC-Light, SourceHanSansSC;
        font-weight: 300;
        color: #65686C;
        line-height: 45px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 6;
        overflow: hidden;
      }

      .img3 {
        cursor: pointer;
        margin: 50px 0;
      }

      .txt4 {
        font-size: 20px;
        // font-family: SourceHanSansSC-Regular, SourceHanSansSC;
        font-weight: 400;
        color: #656565;
        line-height: 30px;
      }
    }

    .r {
      margin-left: 80px;
      position: relative;
      box-sizing: border-box;
      padding-right: 80px;

      .img1 {
        width: 594px;
        height: 796px;
        opacity: 1;
      }

      .img2 {
        top: 20%;
        right: 0;
        position: absolute;
        box-shadow: 5px 0px 46px 0px rgba(#1D3B95, 0.2);
      }
    }
  }

  .block_3 {
    width: 1440px;
    margin: 0 auto;

    .cont {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      grid-gap: 20px;

      img {
        width: 100%;
        cursor: pointer;
      }

      img:nth-child(1) {
        grid-column: 1 / 3;
        grid-row: 1;
      }
    }
  }
}

.block_4_bg {
  width: 100%;
  background: #f0f2fa;
  padding-bottom: 96px;

  .block_4 {
    width: 1440px;
    margin: 0 auto;

    .cont {
      display: flex;

      .l {
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .item {
          box-sizing: border-box;
          background: #FFFFFF;
          border-bottom: 2px solid #FFFFFF;
          padding: 30px;

          .title {
            font-size: 28px;
            // font-family: SourceHanSansSC-Medium, SourceHanSansSC;
            font-weight: 500;
            color: #2F2F2F;
            margin-bottom: 15px;
            text-align: center;
          }

          .jieshao {
            font-size: 20px;
            // font-family: SourceHanSansSC-Regular, SourceHanSansSC;
            font-weight: 400;
            color: #5F5F5F;
            line-height: 36px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
          }
        }
      }

      .r {
        margin-left: 30px;

        .item {
          box-sizing: border-box;
          background: #FFFFFF;
          padding: 30px;
          margin-bottom: 20px;
          border-bottom: 2px solid #FFFFFF;

          .title {
            font-size: 28px;
            // font-family: SourceHanSansSC-Medium, SourceHanSansSC;
            font-weight: 500;
            color: #2F2F2F;
          }

          .jieshao {
            font-size: 20px;
            // font-family: SourceHanSansSC-Regular, SourceHanSansSC;
            font-weight: 400;
            color: #5F5F5F;
            line-height: 36px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            margin: 15px 0 10px;
          }

          .bott {
            display: flex;
            align-items: center;
            justify-content: space-between;

            .time {
              font-size: 18px;
              // font-family: MicrosoftYaHei;
              color: #8F8F8F;
            }

            .bott-r {
              display: flex;
              align-items: center;
              font-size: 18px;
              // font-family: MicrosoftYaHei;
              color: #8F8F8F;
            }
          }
        }

        .item:nth-last-child(1) {
          margin-bottom: 0;
        }


      }

      .item:hover {
        border-bottom: 2px solid #3B4F9F;

        .title {
          color: #3B4F9F;
        }

        .bott-r {
          color: #3B4F9F;

        }
      }
    }
  }
}

.block_5_bg {
  width: 100%;
  background: #fff;
  padding: 96px 0;

  .block_5 {
    width: 1440px;
    margin: 0 auto;

    .top {
      display: flex;
      justify-content: flex-end;

      .btn {
        width: 57px;
        height: 57px;
        border: 1px solid #9F9F9F;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 30px;
        margin: 0 0 30px 15px;
      }
    }

    .bott {
      display: flex;

      .l {
        width: 220px;
        flex-shrink: 0;
        margin-right: 100px;

        .txt1 {
          font-size: 28px;
          // font-family: DIN-Bold, DIN;
          font-weight: bold;
          color: #AFB7BF;
        }

        .txt2 {
          font-size: 36px;
          // font-family: SourceHanSansSC-Medium, SourceHanSansSC;
          font-weight: 500;
          color: #221714;
          margin-top: 25px;
          margin-bottom: 60px;
        }

        .txt3 {
          font-size: 24px;
          // font-family: SourceHanSansSC-Light, SourceHanSansSC;
          font-weight: 300;
          color: #65686C;
          line-height: 50px;
        }

        .img1 {
          margin: 50px 0 20px;
        }

        .txt4 {
          font-size: 20px;
          // font-family: SourceHanSansSC-Regular, SourceHanSansSC;
          font-weight: 400;
          color: #656565;
        }
      }

      .r {
        flex: 1;
        display: flex;
        overflow-y: hidden;

        .item {
          width: 360px;
          flex-shrink: 0;
          display: flex;
          flex-direction: column;
          margin-left: 18px;
          box-sizing: border-box;
          transition: transform 0.5s ease;

          .img {
            width: 100%;
          }

          .info {
            // background: #c77373;
            box-sizing: border-box;
            padding: 25px 20px;
            transition-property: margin;
            transition-duration: .5s;

            .title {
              font-size: 24px;
              // font-family: SourceHanSansSC-Regular, SourceHanSansSC;
              font-weight: 400;
              color: #65686C;
              margin-bottom: 20px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }

            .show {
              font-size: 18px;
              // font-family: SourceHanSansSC-Regular, SourceHanSansSC;
              font-weight: 400;
              color: #65686C;
              line-height: 30px;
            }

            .show-s {
              display: none;
            }
          }
        }

        .item:nth-child(1) {
          margin-left: 0;
        }

        .item:hover {

          .info {
            margin-top: -60px;
            background: #3B4F9F;
            position: relative;
            z-index: 5;

            .title {
              color: #fff;
            }

            .show {
              color: #fff;
            }

            .show-s {
              display: block;
            }
          }
        }
      }
    }
  }
}

.title-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 60px 0;

  .title-en {
    font-size: 28px;
    // font-family: DIN-Bold, DIN;
    font-weight: bold;
    color: #AFB7BF;
    margin-bottom: 30px;
  }

  .title-cn {
    display: flex;
    align-items: center;
    font-size: 36px;
    // font-family: SourceHanSansSC-Medium, SourceHanSansSC;
    font-weight: 500;
    color: #221714;

    span {
      margin: 0 20px;
      width: 25px;
      height: 1px;
      background: #AFB7BF;
    }
  }
}
</style>
<style scoped lang="less">
.home-m {
  .block_1 {
    width: 100%;

    .item {
      .r {
        box-sizing: border-box;
        padding: 20px 20px;

        .txt1 {
          font-size: 35px;
        }

        .txt2 {
          font-size: 25px;
          margin: 5px 0;
        }
      }
    }
  }

  .block_2 {
    width: 100%;
    flex-direction: column;
    box-sizing: border-box;
    padding: 0 50px;

    .r {
      margin-left: 0px;
      margin-top: 50px;
    }
  }

  .block_3 {
    width: 100%;
    box-sizing: border-box;
    padding: 0 50px;

    .cont {
      grid-template-columns: repeat(2, 1fr);
    }
  }

  .block_4 {
    width: 100%;
    box-sizing: border-box;
    padding: 0 50px;

    .cont {
      flex-direction: column;

      .l {
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .item {
          margin-top: 30px;
        }
      }

      .r {
        margin-left: 0px;

        .item {
          margin-bottom: 0px;
          margin-top: 30px;
        }
      }
    }
  }

  .block_5 {
    width: 100%;
    margin: 0 auto;
    box-sizing: border-box;
    padding: 0 50px;

    .top {
      display: none;
    }

    .bott {
      flex-direction: column;

      .l {
        width: 100%;
        margin-bottom: 30px;
      }
      
    }
  }
  
}
</style>